/**
 * Catálogos DC-4 (códigos SIRCE) para Tipo de Agente, Modalidad y Objetivos.
 */
export interface Dc4CatalogItem {
  value: number
  labelKey: string
}

export const DC4_TRAINING_AGENT_TYPES: readonly Dc4CatalogItem[] = [
  {
    value: 1,
    labelKey:
      'administration.certificate.legalAttestationForm.dc4.agentType.options.internal',
  },
  {
    value: 2,
    labelKey:
      'administration.certificate.legalAttestationForm.dc4.agentType.options.external',
  },
  {
    value: 3,
    labelKey:
      'administration.certificate.legalAttestationForm.dc4.agentType.options.other',
  },
]

export const DC4_TRAINING_MODALITIES: readonly Dc4CatalogItem[] = [
  {
    value: 1,
    labelKey:
      'administration.certificate.legalAttestationForm.dc4.modality.options.presential',
  },
  {
    value: 2,
    labelKey:
      'administration.certificate.legalAttestationForm.dc4.modality.options.online',
  },
  {
    value: 3,
    labelKey:
      'administration.certificate.legalAttestationForm.dc4.modality.options.mixed',
  },
]

export const DC4_TRAINING_OBJECTIVES: readonly Dc4CatalogItem[] = [
  {
    value: 1,
    labelKey:
      'administration.certificate.legalAttestationForm.dc4.objective.options.update',
  },
  {
    value: 2,
    labelKey:
      'administration.certificate.legalAttestationForm.dc4.objective.options.newTech',
  },
  {
    value: 3,
    labelKey:
      'administration.certificate.legalAttestationForm.dc4.objective.options.vacancies',
  },
  {
    value: 4,
    labelKey:
      'administration.certificate.legalAttestationForm.dc4.objective.options.riskPrevention',
  },
  {
    value: 5,
    labelKey:
      'administration.certificate.legalAttestationForm.dc4.objective.options.productivity',
  },
]
